import { render, staticRenderFns } from "./ReportBanner.vue?vue&type=template&id=01828552&scoped=true&"
import script from "./ReportBanner.vue?vue&type=script&lang=js&"
export * from "./ReportBanner.vue?vue&type=script&lang=js&"
import style0 from "./ReportBanner.vue?vue&type=style&index=0&id=01828552&prod&lang=scss&scoped=true&"
import style1 from "./ReportBanner.vue?vue&type=style&index=1&id=01828552&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01828552",
  null
  
)

export default component.exports